interface BriefingGroup {
  trackDistMeters?: number;
  descr?: string;
  images?: unknown[];
  documents?: unknown[];
}

/** One label between consecutive visible groups, positioned in the empty space. */
export function flowBriefingGaps(
  groups: BriefingGroup[],
  scale: number,
  coverageMeters: number,
  offset: number,
  formatDistance: (meters: number) => string
): { style: string; remark: string }[] {
  const visible = groups
    .filter((group) => group.descr?.trim() || group.images?.length || group.documents?.length)
    .filter((group) => Number.isFinite(group.trackDistMeters))
    .sort((a, b) => a.trackDistMeters! - b.trackDistMeters!);
  const gaps: { style: string; remark: string }[] = [];
  for (let i = 1; i < visible.length; i++) {
    const previous = visible[i - 1].trackDistMeters!;
    const next = visible[i].trackDistMeters!;
    const start = previous + coverageMeters;
    const height = (next - start) * scale;
    if (height <= 100) continue;
    gaps.push({
      style: `top:${Math.round(offset + start * scale)}px;height:${Math.round(height)}px`,
      remark: formatDistance(next - previous),
    });
  }
  return gaps;
}
